import styled from '@emotion/styled';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

import { customPalette } from '../../../../styles/theme';

export const StyledTextarea = styled(TextareaAutosize)`
    width: 100%;
    min-height: 25px;
    padding: 16px;
    border: 1px solid ${customPalette.grey[100]};
    font-family: inherit;
    font-size: 20px;
    line-height: 1.5;
    resize: none;
    transition: border-color 0.2s ease;
    box-sizing: border-box;
    border-radius: 8px;

    &:focus {
        outline: none;
        border-color: ${customPalette.blue.main};
    }

    &::placeholder {
        color: ${customPalette.grey[400]};
        font-size: 14px;
    }

    &:disabled {
        background-color: ${customPalette.grey[50]};
        color: ${customPalette.grey[400]};
        border-color: ${customPalette.grey[100]};
        cursor: not-allowed;
`;
export const FormGroup = styled.div`
  margin-bottom: 24px;
`;

export const Label = styled.div`
  color: ${customPalette.grey[400]};
  font-size: 14px;
  margin-bottom: 8px;
`;
